<template>
    <div>
        <input
           :id="labelId"
           type="checkbox"
           @change="setChecked"
        />
        <input type="hidden" :name="name" :value="checked">
    </div>
</template>

<script>
    export default {
        name: 'CheckBox',
        props: [
            'fieldId',
            'labelId',
        ],
        components: {},
        computed: {
            checked() {
                return Boolean(this.$store.state.checked[this.labelId]);
            },
            name() {
                return this.field.labels[this.labelId]
            },
            field() {
                const { state } = this.$store

                return state.fields[this.fieldId]
            },
        },
        methods: {
            setChecked(e) {
                this.$store.commit('setChecked', {
                    labelId: this.labelId,
                    checked: e.target.checked
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>
